import React, { createContext, useCallback, useEffect, useState } from "react";

import Cookies from "js-cookie";
import axios from "axios";
import {
  activeWebsite,
  updateRetailWebsiteStatus,
} from "../../services/api/retail/websiteStatusApi";
import {
  getMerchantInfo,
  getSettingsActiveFeatures,
} from "../../services/api/retail/merchantInfoApi";
import ActiveDone from "../../components/Retail/ActiveDone";
import ActiveDoneKiotOnline from "../../components/KiotOnline/ActiveDoneKiotOnline";
import LoadingProgress from "../../components/Retail/LoadingProgress";
import StatusOfflineWebsite from "../../components/Retail/StatusOfflineWebsite";
import SettingKiotOnline from "../../components/KiotOnline/SettingBasic";
import OnboardingRetail from "../../components/Retail/Onboarding";
import OnboardingKiotOnline from "../../components/KiotOnline/Onboarding";
import StatusOfflineWebsiteKiotOnline from "../../components/KiotOnline/StatusOfflineWebsiteKiotOnline";
import { useRouter } from "../../utils/hooks/useRouter";
import { Redirect } from "../../utils/Redirect";
import OnboardingRetailApp from "../../components/Retail/Mobile/Onboarding";
import ActiveDoneMobile from "../../components/Retail/Mobile/ActiveDone";
import SettingRetailMobile from "../../components/Retail/Mobile/SettingBasic";
// import StatusOfflineWebsiteMobile from "../../components/Retail/Mobile/StatusOfflineWebsite";
import { isMobile } from "../../utils/helper";

import {
  getDomain,
  getNamespace,
} from "../../services/domain/domainSetting.service";
import { useDispatch } from "react-redux";
import { setPageLoading } from "../../store/slices/loadingSlice";
import ActiveProgressBasic from "../../components/Retail/ActiveProgress/ActiveProgressBasic";
import ActiveProgressWeb from "../../components/Retail/ActiveProgress/ActiveProgressWeb";
import PosSetting from "../../components/Retail/SettingRetail/PosSetting";
import { setOnboardingSettings } from "../../store/slices/onboardingFeatureSlice";
import { BOOKING_HOTEL_PLATFORM, BOOKING_PLATFORM } from "../../utils/constant";

// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const RetailContext = createContext<{
  formula_default?: any;
  status: number;
  merchantInfo?: IRetailMerchantInfo;
  branchInfo?: IRetailBranchInfo;
  progress: number;
  priceBook: any[];
  active_noty?: boolean;
  link?: string;
  setStatus?: (status: number) => void;
  changeStatusPublished?: (newStatus: boolean) => void;
  turnOnWebsite?: VoidFunction;
  turnOffWebsite?: VoidFunction;
  handActive?: VoidFunction;
  handActiveWeb?: VoidFunction;
  changeStatus?: (newStatus: number) => void;
  setProgress?: React.Dispatch<React.SetStateAction<number>>;
  updateActive?: (newStatus: 0 | 1) => void;
  apiUpdateActive?: (newStatus: 0 | 1) => void;
  setPriceBook?: (priceBook: any) => void;
  setActiveNoty?: (active_noty: boolean) => void;
  updateMerchantData?: (data: IRetailMerchantInfoDraff) => void;
  updateBranchData?: (data: IRetailBranchInfoDraft) => void;
  setMerchantInfo?: (merchant: IRetailMerchantInfo) => void;
  setBranchInfo?: (branch: IRetailBranchInfo) => void;
  getWebsiteUrl?: () => string;
}>({ status: 2, progress: 5, priceBook: [] });

export const RetailContextProvider = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  const [status, setStatus] = useState<number>(2);
  // console.log("status", status);

  const [loadingProgressBar, setLoadingProgressBar] = useState(false);
  const [progress, setProgress] = useState(5);
  const [branchInfo, setBranchInfo] = useState<IRetailBranchInfo | undefined>(
    undefined
  );
  const [merchantInfo, setMerchantInfo] = useState<
    IRetailMerchantInfo | undefined
  >(undefined);
  const [priceBook, setPriceBook] = useState<any | undefined>(undefined);
  const [active_noty, setActiveNoty] = useState(false);

  const [link, setLink] = useState("https://www.mykiot.vn/");
  const [namespace] = useState(merchantInfo?.ref_id || "namespace");

  useEffect(() => {
    setLink(`${process.env.REACT_APP_THEME_IFRAME}/retail/${namespace}`);
  }, [namespace]);

  useEffect(() => {
    const namespace = getNamespace(merchantInfo, branchInfo);
    setLink(`${process.env.REACT_APP_THEME_IFRAME}/retail/${namespace}`);
  }, [branchInfo, merchantInfo]);

  const handActive = () => {
    if (!merchantInfo?.id || !branchInfo?.id) return;
    activeWebsite({
      merchantId: merchantInfo.id,
      branchId: branchInfo.id,
      platform: router.query.platform,
    }).then(() => {
      setStatus(1);
    });
  };
  const handActiveWeb = async () => {
    if (!merchantInfo?.id || !branchInfo?.id) return;
    return activeWebsite({
      merchantId: merchantInfo.id,
      branchId: branchInfo.id,
      platform: router.query.platform,
    });
  };

  const changeStatus = (newStatus: number) => {
    setStatus(newStatus);
  };

  const changeStatusPublished = (newStatus: boolean) => {
    setBranchInfo((preValue) => {
      if (!preValue) return undefined;
      return {
        ...preValue,
        is_active: newStatus,
      };
    });
  };

  const turnOnWebsite = () => {
    initLoadingProgressBar();
    setTimeout(() => {
      setStatus(4);
      setLoadingProgressBar(false);
    }, 10 * 1000);
  };

  const turnOffWebsite = () => {
    setStatus(5);
  };
  const getWebsiteUrl = () => {
    const domain = getDomain(merchantInfo?.domain, merchantInfo?.domain_status, merchantInfo?.brand_type);
    if (domain && domain !== process.env.REACT_APP_THEME_IFRAME) {
      return domain;
    }
    return branchInfo ? branchInfo.url : "";
  };

  const initLoadingProgressBar = () => {
    setProgress(5);
    setLoadingProgressBar(true);
  };

  const getDataMerchant = async () => {
    const platform = router.query.platform;
    if (!platform || typeof platform !== "string") {
      return () => {
        Redirect({ to: "/session-expired" });
      };
    }
    const promises = [getMerchantInfo({ platform })];
    if (
      router.query.platform === "retail" ||
      router.query.platform === BOOKING_PLATFORM ||
      router.query.platform === BOOKING_HOTEL_PLATFORM
    ) {
      getSettingsActiveFeatures(platform);
    }
    try {
      const [responseMerchant, onboardingSetting] = await Promise.all(promises);
      if (responseMerchant.branch && responseMerchant.merchant) {
        dispatch(setPageLoading({ value: false }));
        setBranchInfo(responseMerchant.branch);
        setMerchantInfo(responseMerchant.merchant);
        setStatus(getStatus(responseMerchant.branch));
        Cookies.set("mykiot_platform", platform);
        Cookies.set("mykiot_merchant_id", responseMerchant.merchant.id);
        Cookies.set("mykiot_branch_id", responseMerchant.branch.id);
      }

      if (onboardingSetting.data) {
        dispatch(setOnboardingSettings({ value: onboardingSetting.data }));
      }
    } catch (e) {
      Redirect({ to: "/internal-server-error" });
    }
  };
  const updateMerchantData = (data: IRetailMerchantInfoDraff) => {
    if (!merchantInfo) return;
    const newDataMerchant = { ...merchantInfo, ...data };
    setMerchantInfo(newDataMerchant);
  };
  const updateBranchData = (data: IRetailBranchInfoDraft) => {
    if (!branchInfo) return;
    const newDataBranch = { ...branchInfo, ...data };
    setBranchInfo(newDataBranch);
  };

  const getStatus = (branchInfo: IRetailBranchInfo) => {
    if (router.query.platform === "retail") {
      return branchInfo.is_onboarding ? 4 : 0;
    }
    if (!branchInfo.is_installed) {
      return 0;
    }
    if (branchInfo.is_syncing) {
      return 1;
    }
    if (branchInfo.is_active && !branchInfo.is_syncing) {
      return 4;
    }
    if (!branchInfo.is_active) {
      return 5;
    }

    return 0;
  };

  const updateActive = async (newStatus: 0 | 1) => {
    await apiUpdateActive(newStatus);
    changeStatus(newStatus ? 4 : 5);
    if (!branchInfo) return true;
    setBranchInfo(
      Object.assign(branchInfo, { is_active: (newStatus && true) || false })
    );
    return true;
  };

  const apiUpdateActive = async (newStatus: 0 | 1) => {
    const platform = router.query.platform;
    if (!platform || typeof platform !== "string") {
      return () => {
        Redirect({ to: "/session-expired" });
      };
    }
    await updateRetailWebsiteStatus({ step_code: newStatus, platform });
  };

  useEffect(() => {
    if ([4, 5].includes(status)) {
      const counterInterval = setInterval(() => {
        if (progress >= 90) return;
        setProgress(progress + 10);
      }, 500);
      return () => {
        clearInterval(counterInterval);
      };
    }
  }, [progress, status]);

  /**
   * @desc: in case endpoint not append code to url. eg: kiotonline
   */
  const app_platforms = ["kiotonline"];
  const isHideCode = (platform: string) => {
    if (app_platforms.includes(platform)) {
      return true;
    }
    return false;
  };

  /**
   * set token
   */
  useEffect(() => {
    // if (router.isReady && !router.query.code) {
    if (!router.query.code) {
      if (!isHideCode(router.query.platform as string)) {
        Redirect({ to: "/session-expired" });
      }
    }
    if (router.query.code) {
      Cookies.set("mykiot_access_token", router.query.code.toString());
      axios.defaults.headers.common.Authorization = `Bearer ${router.query.code.toString()}`;
      getDataMerchant();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.code, router.query.platform]);

  useEffect(() => {
    switch (status) {
      case 0:
        (window as any).updateTitleNav("Website bán hàng", "retail");
        break;
      case 1:
        (window as any).updateTitleNav("Website bán hàng", "retail");
        break;
      case 3:
        (window as any).updateTitleNav("Kích hoạt thành công", "retail");
        break;
      case 4:
        (window as any).updateTitleNav("Thiết lập website", "retail");
        break;
      case 5:
        (window as any).updateTitleNav("Thiết lập website", "retail");
        break;
    }
    if (status === 1 || loadingProgressBar) {
      setProgress(5);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, loadingProgressBar]);

  /**
   * Onboarding page
   */
  const Onboarding = useCallback(() => {
    switch (router.query.platform) {
      case "retail":
        return isMobile() ? <OnboardingRetailApp /> : <OnboardingRetail />;
      case "kiotonline":
        return <OnboardingKiotOnline />;
      default:
        return <></>;
    }
  }, [router.query.platform]);

  /**
   * ActiveProgress page
   */
  const ActiveProgress = useCallback(() => {
    if (router.query.platform === "retail" && !isMobile()) {
      return <ActiveProgressWeb />;
    }
    return <ActiveProgressBasic />;
  }, [router.query.platform]);

  /**
   * Active Done
   */
  const ActiveDoneBasic = useCallback(() => {
    switch (router.query.platform) {
      case "retail":
        return isMobile() ? <ActiveDoneMobile /> : <ActiveDone />;
      case "kiotonline":
        return <ActiveDoneKiotOnline />;
      default:
        return <></>;
    }
  }, [router.query.platform]);

  /**
   * Setting page
   */

  const Setting = useCallback(() => {
    switch (router.query.platform) {
      case "retail":
        return isMobile() ? <SettingRetailMobile /> : <PosSetting />;
      case "kiotonline":
        return <SettingKiotOnline />;
      default:
        return <></>;
    }
  }, [router.query.platform]);

  const StatusOfflineWebsiteBasic = useCallback(() => {
    switch (router.query.platform) {
      case "retail":
        return isMobile() ? (
          //todo : sửa lại thành màn thiết lập nâng cao kể cả khi đã tắt website
          // <StatusOfflineWebsiteMobile />
          <SettingRetailMobile />
        ) : (
          <StatusOfflineWebsite />
        );
      case "kiotonline":
        return <StatusOfflineWebsiteKiotOnline />;
      default:
        return <></>;
    }
  }, [router.query.platform]);

  useEffect(() => {
    dispatch(setPageLoading({ value: true }));
  }, []);

  return (
    <RetailContext.Provider
      value={{
        status,
        merchantInfo,
        branchInfo,
        priceBook,
        progress,
        active_noty,
        link,
        turnOnWebsite,
        turnOffWebsite,
        handActive,
        changeStatusPublished,
        handActiveWeb,
        changeStatus,
        updateActive,
        setPriceBook,
        setActiveNoty,
        setProgress,
        updateMerchantData,
        apiUpdateActive,
        setMerchantInfo,
        setBranchInfo,
        getWebsiteUrl,
        updateBranchData,
      }}
    >
      {status === 0 && <Onboarding />}
      {status === 1 && <ActiveProgress />}
      {status === 3 && <ActiveDoneBasic />}
      {status === 4 && <Setting />}
      {status === 5 && <StatusOfflineWebsiteBasic />}
      {loadingProgressBar && <LoadingProgress />}
    </RetailContext.Provider>
  );
};
